import { i18n } from '@/i18n';
/**
 * 荣誉等级信息
 */
export interface HonoraryLevelConfig {
  /**
   *  等级编号
   */
  level: number;
  /**
   * 获得该等级需要捐贈的印花数
   */
  target: number;
  /**
   * 等级名称
   */
  nickName: string;
  /**
   * 等级皇冠
   */
  icon?: string;
}

/**
 * 荣誉等级配置
 */
export const HONORARY_LEVELS_CONFIG: HonoraryLevelConfig[] = [
  {
    level: 1, // 等级编号
    target: 50, // 获得该等级需要捐贈的印花数
    nickName: i18n('愛心王者'), // 荣誉等级称号
    icon: 'crown-yellow',
  },
  {
    level: 2,
    target: 30,
    nickName: i18n('愛心元老'),
    icon: 'crown-grey',
  },
  {
    level: 3,
    target: 20,
    nickName: i18n('愛心大使'),
    icon: 'crown-brown',
  },
  {
    level: 4,
    target: 10,
    nickName: i18n('愛心精英'),
  },
  {
    level: 5,
    target: 5,
    nickName: i18n('愛心達人'),
  },
  {
    level: 6,
    target: 3,
    nickName: i18n('愛心見習'),
  },
  {
    level: 7,
    target: 1,
    nickName: i18n('愛心新秀'),
  },
];
